if (module.hot) {
  module.hot.accept();
}

import './modules/ToggleTarget';
// import './modules/IsSticky';
import './modules/Accordion';
import './modules/Navigation';
import './modules/AddClassOnScroll';
// import './modules/CookieBar';
import './modules/FormValidator';
import './modules/SimpleGallery';
import './modules/Slider';

// Make sure image are visible when printing
window.onbeforeprint = () => {
  const imgs = document.querySelectorAll('img');
  imgs.forEach(img => img.removeAttribute('loading') )
};